export const getHighlightedText = (text: string, highlight: string) => {
  const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedHighlight, "gi");

  return text.replace(regex, (match) => `<strong>${match}</strong>`);
};
